<div class="m-2">
    <vw-toast-popup [isOpen]="isOpen" width="100%" borderRadius="20px" paddingTop="160%" (close)="onClose()"
        [toastCustomClass]="'mx-2'">
        <div class="mt-8 flex flex-col gap-4 mx-4">
            <p class="text-center text-lg font-bold grow">{{ 'agenda.sort.title' | translate }}</p>
            <div class="flex flex-col gap-2">
                <div class="flex items-center gap-2 bg-grey-50 rounded-full p-2 px-4 text-grey-700"
                    [ngClass]="{ 'border-2 border-primary-500': sort === 'name' && sortDirection === 'asc' }"
                    (click)="onSort('name', 'asc')">
                    <p for="sort-by-name">{{ 'agenda.sort.name.asc' | translate }}</p>
                </div>
                <div class="flex items-center gap-2 bg-grey-50 rounded-full p-2 px-4 text-grey-700"
                    [ngClass]="{ 'border-2 border-pzrimary-500': sort === 'name' && sortDirection === 'desc' }"
                    (click)="onSort('name', 'desc')">
                    <p for="sort-by-name">{{ 'agenda.sort.name.desc' | translate }}</p>
                </div>
            </div>
        </div>
    </vw-toast-popup>
</div>